module.exports = __webpack_public_path__ + "img/united-kingdom-flag-icon-256.bd640a98.png";